import { Box, createStyles, Grid, IconButton, makeStyles, Paper, Theme, Typography } from "@material-ui/core";
import { DirectionsBike, Storefront } from "@material-ui/icons";
import React from "react";
import { useSelector } from "react-redux";
import useUserFormFunctions from "../../hooks/useUserFormFunctions";
import { DELIVERY, TAKEOUT } from "../../pages/UserForm";
import { selectCleverlynk, selectDeliveryType, selectIsMobile } from "../../redux/slices/cleverlynkSlice";

import { useTranslation } from "react-i18next";
import "../../i18n/config";
import { PFXOrderFulfillmentType } from "../../models/Interfaces";

interface IDeliveryTypeSlider {
  onClick: () => void;
}

const DeliveryTypeSlider = ({ onClick }: IDeliveryTypeSlider) => {
  const cleverlynk = useSelector(selectCleverlynk);
  const deliveryType = useSelector(selectDeliveryType);
  const isMobile = useSelector(selectIsMobile);

  const { t } = useTranslation();

  const { onChangeDeliveryType } = useUserFormFunctions();

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      paper: {
        boxShadow: "1pt 1pt 3px #0000001f inset",
        position: "relative",
        backgroundColor: "#f2f2f2",
        width: 250,
        height: 65,
        borderRadius: 9,
      },
      slider: {
        height: 59,
        margin: 3,
        position: "absolute",
        width: 125,
        backgroundColor: `${theme.palette.secondary.main}`,
        boxShadow: "1pt 1pt 3px #0000005c",
        borderRadius: "inherit",
        transitionProperty: "left",
        transitionDuration: "400ms",
        left: 0,
        "&.right": {
          left: 119,
        },
      },
      iconButton: {
        width: "100%",
        height: "100%",
        borderRadius: "inherit",
        "&:hover": {
          backgroundColor: "transparent",
        },
      },
      wrapper: {
        height: 100,
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "center",
      },
      takeoutIcon: {
        fill:
          deliveryType === PFXOrderFulfillmentType.TAKEOUT
            ? theme.palette.secondary.contrastText
            : theme.palette.grey[500],
      },
      deliveryIcon: {
        fill:
          deliveryType === PFXOrderFulfillmentType.DELIVERY
            ? theme.palette.secondary.contrastText
            : theme.palette.grey[500],
      },
      takeoutLabel: {
        textAlign: "center",
        color: deliveryType === PFXOrderFulfillmentType.TAKEOUT ? theme.palette.grey[900] : theme.palette.grey[500],
        fontWeight: "bold",
      },
      deliveryLabel: {
        textAlign: "center",
        color: deliveryType === PFXOrderFulfillmentType.DELIVERY ? theme.palette.grey[900] : theme.palette.grey[500],
        fontWeight: "bold",
      },
    })
  );

  const classes = useStyles();

  return (!!cleverlynk?.deliveryPrice || cleverlynk?.geolocationInfo) && cleverlynk?.takeOut ? (
    <Grid item xs={12} style={{ padding: 0 }} onClick={onClick}>
      <Box>
        <Box pt={isMobile ? 2 : 3}>
          <div className={classes.wrapper}>
            <div className={classes.paper}>
              <div
                className={`${deliveryType === PFXOrderFulfillmentType.TAKEOUT ? "right" : ""} ${
                  classes.slider
                }`}></div>
              <Grid container style={{ margin: 3, height: "calc(100% - 6px)", width: "calc(100% - 6px)" }}>
                <Grid item xs={6} container justifyContent="center" alignItems="center">
                  <IconButton
                    className={classes.iconButton}
                    onClick={() => onChangeDeliveryType(PFXOrderFulfillmentType.DELIVERY)}>
                    <DirectionsBike style={{ fontSize: "2.1rem" }} className={classes.deliveryIcon} />
                  </IconButton>
                </Grid>
                <Grid item xs={6} container justifyContent="center" alignItems="center">
                  <IconButton
                    className={classes.iconButton}
                    onClick={() => onChangeDeliveryType(PFXOrderFulfillmentType.TAKEOUT)}>
                    <Storefront style={{ fontSize: "1.9rem" }} className={classes.takeoutIcon} />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid container justifyContent="space-evenly">
                <Grid item container justifyContent="center" xs={6}>
                  <Typography variant="overline" className={classes.deliveryLabel}>
                    {" "}
                    {t("delivery")}{" "}
                  </Typography>
                </Grid>
                <Grid item container justifyContent="center" xs={6}>
                  <Typography variant="overline" className={classes.takeoutLabel}>
                    {" "}
                    {t("pickup")}{" "}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </div>
        </Box>
      </Box>
    </Grid>
  ) : null;
};

export default DeliveryTypeSlider;
